import { Grid } from "@material-ui/core";
import React from "react";
import { useAddMyModuleDocumentMutation, useDeleteMyModuleDocumentMutation } from "../../../api/rtk/MeApi";
import { DocumentReferenceViewModel } from "../../../model/DocumentReferenceViewModel";
import DocumentList from "../../common/DocumentList";
import UploadDropZone from "../../common/UploadDropZone";

type DocumentsManagerProps = {
  moduleId: string;
  documents: DocumentReferenceViewModel[];
  readonly?: boolean;
};
const DocumentsManager = ({ moduleId, documents, readonly }: DocumentsManagerProps) => {
  const [addModuleDocument] = useAddMyModuleDocumentMutation();
  const [deleteModuleDocument] = useDeleteMyModuleDocumentMutation();

  return (
    <Grid item container spacing={2} style={{ marginTop: "12px" }}>
      <Grid item xs={12} md={4}>
        {!readonly && <UploadDropZone accept=".jpg,.jpeg,.png,.pdf" postFileFn={(file) => addModuleDocument({ moduleId, file })} />}
      </Grid>
      <Grid item xs={12} md={8}>
        <DocumentList
          documents={documents}
          onDeleteFile={
            readonly
              ? undefined
              : (file: DocumentReferenceViewModel) => deleteModuleDocument({ moduleId, fileName: file.name })
          }
        />
      </Grid>
    </Grid>
  );
};

export default DocumentsManager;
